interface IProps {
  className?: string
}
export const GradientSvg = (props: IProps) => {
  const { className } = props

  return (
    <svg
      width="78"
      height="79"
      viewBox="0 0 78 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_f_11180_22033)">
        <circle cx="40" cy="42.9999" r="30" fill="#3921EA" fillOpacity="0.64" />
      </g>
      <g filter="url(#filter1_f_11180_22033)">
        <circle cx="36" cy="39" r="30" fill="#14CDE5" fillOpacity="0.4" />
      </g>
      <g filter="url(#filter2_f_11180_22033)">
        <ellipse
          cx="39.344"
          cy="37.6411"
          rx="31.2921"
          ry="16.2772"
          transform="rotate(124.103 39.344 37.6411)"
          fill="#DD77C0"
          fillOpacity="0.86"
        />
      </g>
      <g filter="url(#filter3_f_11180_22033)">
        <circle cx="42" cy="36" r="30" fill="#FF1BE1" fillOpacity="0.4" />
      </g>
      <defs>
        <filter
          id="filter0_f_11180_22033"
          x="4"
          y="6.99988"
          width="72"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3"
            result="effect1_foregroundBlur_11180_22033"
          />
        </filter>
        <filter
          id="filter1_f_11180_22033"
          x="0"
          y="3"
          width="72"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3"
            result="effect1_foregroundBlur_11180_22033"
          />
        </filter>
        <filter
          id="filter2_f_11180_22033"
          x="11.2188"
          y="4.16261"
          width="56.251"
          height="66.957"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3"
            result="effect1_foregroundBlur_11180_22033"
          />
        </filter>
        <filter
          id="filter3_f_11180_22033"
          x="6"
          y="0"
          width="72"
          height="72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="3"
            result="effect1_foregroundBlur_11180_22033"
          />
        </filter>
      </defs>
    </svg>
  )
}
